import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { Btn } from 'AbstractElements';
import DropzoneCommon from 'Component/Learning/Common/Upload/Dropzone';
import AudioPlayer from 'Component/Learning/DetailSubMateri/AudioPlayer';

/**
 * AudioMediaSection (presentational)
 * - Preview audio (jika update + ada link)
 * - Upload audio via DropzoneCommon
 * - Delete handler tetap dari parent
 */
export default function AudioMediaSection(props) {
  const {
    isUpdate,
    audioLink,
    onDelete,
    onChangeStatus,
    accept = '.mp3',
  } = props;

  return (
    <>
      {(isUpdate === true && audioLink) && (
        <FormGroup className="mb-3">
          <Label
            for="validationImage"
            style={{ fontWeight: 'bold', marginBottom: '15px', marginRight: '10px' }}
          >
            Preview Audio Soal :
          </Label>

          <Btn attrBtn={{ className: 'btn btn-danger btn-sm', onClick: onDelete }}>
            <i className="fa fa-trash fa-lg"></i>
          </Btn>

          <AudioPlayer link={audioLink} />
        </FormGroup>
      )}

      <DropzoneCommon
        label={'Audio Soal'}
        inputContent={audioLink ? 'Audio Soal tersedia' : 'Silahkan upload audio'}
        handleChangeStatus={onChangeStatus}
        accept={accept}
      />
    </>
  );
}